import { render, staticRenderFns } from "./CampaignHeader.vue?vue&type=template&id=c87b60ac&scoped=true&"
import script from "./CampaignHeader.vue?vue&type=script&lang=js&"
export * from "./CampaignHeader.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHeader.vue?vue&type=style&index=0&id=c87b60ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87b60ac",
  null
  
)

export default component.exports